/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable react/jsx-child-element-spacing */
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import HelpIcon from '@material-ui/icons/Help';
import ReactTooltip from 'react-tooltip';
import Link from '@material-ui/core/Link';
import { withTranslation, Trans } from 'react-i18next';

import StateBadge from './StateBadge';
import { GetFormat, convertToLangKey } from '../../AppUtil/AppUtil';
import PaymentBadge from './PaymentBadge';
import Base from '../Common/LoanViewComponent';
import Columns from '../Common/LoanViewComponent/Column';
import Fields from '../Common/LoanViewComponent/Fields';
import { popUpForItemDescribed } from '../../SweetAlertUtil/util';
import StatesService from '../../Service/StatesService';
import { hot } from 'react-hot-loader';

const LOAN_STATES = window.AppConfig.LOAN_STATES;
const PAYMENT_STATUS = window.AppConfig.PAYMENT_STATUS;

class BaseDetailGuarantor extends Component {
	constructor(props) {
		super(props);
		this.state = {
			stateName: '',
			_isLoading: true,
			_openEditScreen: '',
			_openScreen: ''
		};
		this.getStateData();
	}
	getStateData = async () => {
		const stateData = await StatesService.getStateById(this.props.loanObject.lender_state);
		this.setState({ stateName: stateData.name, _isLoading: false });
	};

	backSummaryScreen = () => {
		this.setState({
			_openScreen: ''
		});
	};

	render() {
		// NOSONAR

		const { t } = this.props;
		return (
			<Base isLoading={this.state._isLoading}>
				<Columns>
					<Fields
						heading={t('label.borrower')}
						value={
							<div>
								<Link
									href="#"
									onClick={e => {
										e.preventDefault();
										this.props.onClickForName('BORROWER');
									}}
									style={{ fontSize: 'medium' }}
									variant="body2">
									{this.props.loanObject.borrower.name ? this.props.loanObject.borrower.name : 'None'}
								</Link>{' '}
							</div>
						}
					/>
					<Fields
						heading={t('label.lender')}
						value={
							<div>
								{this.props.loanObject.lender.name ? (
									<Link
										href="#"
										onClick={e => {
											e.preventDefault();
											this.props.onClickForName('LENDER');
										}}
										style={{ fontSize: 'medium' }}
										variant="body2">
										{this.props.loanObject.lender.name}
									</Link>
								) : (
									<p>'None'</p>
								)}
							</div>
						}
					/>
					<Fields value={`₱${this.props.loanObject.principal}`} heading={t('view_detail.loan_amount')} />
					<Fields
						value={<StateBadge state={this.props.loanObject.state} />}
						heading={t('view_detail.loan_status')}
					/>
					<Fields
						value={
							this.props.loanObject.disbursal_date
								? GetFormat(this.props.loanObject.disbursal_date)
								: GetFormat(this.props.loanObject.start_date)
						}
						heading={t('view_detail.loan_start_date')}
					/>
					<Fields
						value={
							this.props.loanObject.next_installment_details
								? GetFormat(this.props.loanObject.next_installment_details.installment_date)
								: GetFormat(this.props.loanObject.first_installment_date)
						}
						heading={t('view_detail.next_payment_date')}
					/>
					<Fields
						value={this.props.loanObject.no_of_installments}
						heading={t('view_detail.number_of_installments')}
					/>
					<Fields
						heading={t('view_detail.additional_terms_conditions')}
						value={this.props.loanObject.additional_terms || t('profile.none')}
					/>
				</Columns>
				<Columns>
					<Fields value={this.props.loanObject.id} heading={t('view_detail.loan_number')} />
					<Fields
						value={`${this.props.loanObject.annual_rate}` + t('label.annually')}
						heading={t('view_detail.interest_rate')}
					/>
					<p className="light-gray">
						{t('view_detail.principal_interest')}&nbsp;&nbsp;
						<span data-for="min-tooltip" data-tip id="min-tooltip">
							<HelpIcon />
						</span>
					</p>
					<p>₱{parseFloat(this.props.loanObject.total).toFixed(2)}</p>

					<Fields
						value={t(`label.${convertToLangKey(this.props.loanObject.frequency)}`)}
						heading={t('view_detail.frequency')}
					/>
					<Fields
						value={GetFormat(this.props.loanObject.end_date)}
						heading={t('view_detail.loan_end_date')}
					/>
					<Fields
						value={`₱${parseFloat(
							this.props.loanObject.next_installment_details
								? this.props.loanObject.next_installment_details.emi_amount
								: this.props.loanObject.emi_amount
						).toFixed(2)}`}
						heading={t('view_detail.next_payment_amount')}
					/>
					<Fields
						value={
							this.props.loanObject.loan_workflow_id === 3 ? (
								<Link
									href="#"
									onClick={e => {
										e.preventDefault();
										popUpForItemDescribed(this.props.loanObject.item_purchased);
									}}
									style={{ fontSize: 'medium' }}>
									{t('view_detail.pay_for_something')}
								</Link>
							) : (
								t(`label.${convertToLangKey(this.props.loanObject.reason)}`)
							)
						}
						heading={t('view_detail.loan_purpose')}
					/>
					<Fields
						value={this.props.loanObject.collateral || t('profile.none')}
						heading={t('view_detail.collateral')}
					/>
					<p className="light-gray">
						{t('view_detail.loan_funding_status')}&nbsp;&nbsp;
						<span data-for="max-tooltip" data-tip id="max-tooltip">
							<HelpIcon />
						</span>
					</p>
					<p>
						{(() => {
							if (
								this.props.loanObject.state === LOAN_STATES.APPROVE ||
								this.props.loanObject.state === LOAN_STATES.COMPLETED ||
								this.props.loanObject.state === LOAN_STATES.POST_MODIFIED
							) {
								if (this.props.loanObject.disbursal_mode === 'ACH') {
									return <PaymentBadge status={PAYMENT_STATUS.COMPLETED} />;
								} else if (this.props.loanObject.disbursal_mode === 'OFFLINE') {
									return <PaymentBadge status={PAYMENT_STATUS.CHEQUE_CASH} />;
								} else {
									return <PaymentBadge status={'NA'} />;
								}
							} else {
								return t('view_detail.pending_loan_acceptance');
							}
						})()}
					</p>
					<ReactTooltip id="min-tooltip" place="top" role="min-tooltip" aria-haspopup="true" effect="solid">
						{t('view_detail.tooltip_principal_interest_rate')}
						<br />
					</ReactTooltip>
					<ReactTooltip id="max-tooltip" place="top" role="max-tooltip" aria-haspopup="true" effect="solid">
						<Trans i18nKey="view_detail.tooltip_funding_status">
							Funds Transfer in Progress = The Lender will be transferring
							<br />
							the loan funds from their wallet to yours
							<br />
							Check/Cash = The Lender will be providing the
							<br />
							funds via cash or check on a specific date
							<br />
							Pending Loan Acceptance = The loan is awaiting
							<br />
							final approval by the other party
						</Trans>
					</ReactTooltip>
					<ReactTooltip aria-haspopup="true" place="top" role="view-detail" effect="solid" id="view-detail">
						{t('label.view_details')}
					</ReactTooltip>
				</Columns>
				{this.props.generateAction()}
				{this.props.genrateButton('buttons.view_amortization_table', this.props.openAmortizationTable)}
				<Grid className="no-shadow" container spacing={2} id="reduce-width" justify="center">
					<Grid item sm={8} xs={12}>
						<Button
							aria-label="add"
							fullWidth
							type="submit"
							onClick={this.props.closeLoanDetail}
							style={{ backgroundColor: 'darkblue', color: 'white' }}>
							{t('buttons.back')}
						</Button>
					</Grid>
				</Grid>
			</Base>
		);
	}
}

export default hot(module)(withTranslation()(BaseDetailGuarantor));
